import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Link as DSLink,
  Icon,
  Item,
  Listbox,
  Span,
} from "@icg360/design-system";

import { usePolicyDetail, usePolicyPlatformId } from "data/ss-data-hooks";
import { useNavItems } from "hooks/useNavItems";

import styles from "./mobile-nav-menu.module.scss";

type MobileNavMenuProps = {
  onClose: () => void;
  onPolicySelector?: () => void;
};

export const MobileNavMenu = ({
  onClose,
  onPolicySelector,
}: MobileNavMenuProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const selectedPolicyId = usePolicyPlatformId();
  const { data } = usePolicyDetail();

  const navItems = useNavItems();

  const onSelectionChange = useCallback(
    (selection: Set<string>) => {
      onClose();
      const path = selection.keys().next().value;
      navigate(path);
    },
    [navigate, onClose],
  );

  return (
    <div className={styles.wrapper}>
      <div>
        {onPolicySelector ? (
          <button
            className={styles.currentPolicyBtn}
            onClick={onPolicySelector}
            data-testid="mobile-policy-select-btn"
            type="button"
          >
            <Span bold>{data?.userDetails.propertyAddress?.street1}</Span>
            {data?.userDetails.propertyAddress?.street2 ? (
              <Span bold> {data?.userDetails.propertyAddress?.street2}</Span>
            ) : null}
            <Span>{` (Policy #${selectedPolicyId})`}</Span>
            <DSLink className={styles.switchLinkDS}>
              Switch to a different policy
            </DSLink>
          </button>
        ) : null}
        <Listbox
          items={navItems}
          className={styles.navBoxDS}
          selectedKeys={new Set([pathname])}
          selectionMode="single"
          onSelectionChange={onSelectionChange}
          aria-label="main navigation"
        >
          {({ to, title, iconName }) => (
            <Item key={to} textValue={title.toLowerCase()}>
              <div className={styles.navItem}>
                <Icon name={iconName} />
                {title}
              </div>
            </Item>
          )}
        </Listbox>
      </div>
    </div>
  );
};
